import { styled } from "goober";
import { Panel } from "./workflowsLayout";

export const UnitsChartCard = styled(Panel)`
  min-height: 0;
  padding: 24px;
  border-radius: 16px;
  gap: 16px;

  @container units-charts (max-height: 540px) {
    padding: 12px 16px;
    gap: 8px;
  }
`;

export const unitsMonthLabel = new Intl.DateTimeFormat("en-US", {
  month: "long",
  year: "numeric",
  timeZone: "UTC",
});
